import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { i18n } from './plugins/i18n'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        authenticated: false,
        registered: false,
        user: {},
        errors: {},
        countries: null,
        nationalities: null,
        typesvisa: null,
        globalError: false,
        langLocal: 'fr',
        isdark: false,
        sejourdays: [],
        birthCountries: null,
        current_route: null
    },
    getters: {
        current_route(state) {
            return state.current_route
        },
        sejourdays(state) {
            return state.sejourdays
        },
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user
        },
        registered(state) {
            return state.registered
        },

        errors(state) {
            return state.errors
        },
        countries(state) {
            return state.countries
        },
        nationalities(state) {
            return state.nationalities
        },
        typesvisa(state) {

            try {

                let typesvisa = state.typesvisa.map((e) =>
                Object.assign(e, {
                    designation: i18n.t(i18n.messages['reverseLocale'][e.visa_designation])
                }),
            )

            let visas = Object.entries(typesvisa).map((arr) => ({
                id: arr[1].id,
                visa_designation: arr[1].designation,
            }))

            return visas
                
            } catch (error) {
                
            }
           
        },
        globalError(state) {
            return state.globalError
        },
        langLocal(state) {
            return state.langLocal
        },
        isdark(state) {
            return state.isdark
        },
        birthCountries(state) {
            return state.birthCountries
        }
    },
    mutations: {
        SET_CURRENT_ROUTE(state, value) {
            state.current_route = value
        },
        SET_SEJOURDAYS(state, value) {
            state.sejourdays = value

        },
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value
        },
        SET_REGISTERED(state, value) {
            state.registered = value
        },
        SET_USER(state, value) {
            state.user = value
        },

        SET_ERRORS(state, value) {
            state.errors = value
        },
        CLEAR_ERRORS(state) {
            state.errors = {}
        },
        SET_COUNTRIES(state, value) {
            state.countries = value
        },
        SET_NATIONALITIES(state, value) {
            state.nationalities = value
        },
        SET_TYPESVISA(state, value) {
            state.typesvisa = value
        },
        SET_GLOBAL_ERROR(state, value) {
            state.globalError = value
        },
        SET_LANGLOCAL(state, value) {
            state.langLocal = value
            i18n.locale = state.langLocal
        },
        SET_ISDARK(state, value) {
            state.isdark = value
        },
        SET_BIRTHCOUNTRIES(state, value) {
            state.birthCountries = value
        },

    },
    actions: {
        setCurrentRoute({ commit }, payload) {
            commit('SET_CURRENT_ROUTE', payload)
        },
        clear_registered({ commit }) {
            commit('SET_REGISTERED', false)
        },
        async login({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post('login', payload)
                if (response.status == 200 && response.status <= 299) {
                    commit('SET_USER', response.data)
                    commit('SET_AUTHENTICATED', true)
                }
            } catch (e) {
                if (e.response.status === 422) {
                    //commit('SET_ERRORS', e.response.data.errors);
                    let errors = {}
                    if (e.response.data.errors['email']) {
                        errors = {
                            email: {
                                fr: i18n.messages['fr']['confirm_email_error'],
                                en: i18n.messages['en']['confirm_email_error'],
                            },
                        }
                    } else {
                        errors = {
                            password: {
                                fr: i18n.messages['fr']['password_error'],
                                en: i18n.messages['en']['password_error'],
                            },
                        }
                    }
                    commit('SET_ERRORS', errors)
                    commit('SET_AUTHENTICATED', false)
                } else {

                    let errors = {
                            credentiel: {
                                fr: i18n.messages['fr']['credentiel'],
                                en: i18n.messages['en']['credentiel'],
                            },
                        }
                        // commit('SET_ERRORS', e.response.data);
                    commit('SET_ERRORS', errors)
                    commit('SET_AUTHENTICATED', false)
                }
            }
        },
        async getUser({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            let response = await axios.get('/api/me')

            let { connected } = response.data
            commit('SET_AUTHENTICATED', connected)
        },
        async register({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post('register', payload)

               
                commit('SET_REGISTERED', true)
            } catch (e) {
                if (e.response.status === 422) {
                    //commit('SET_ERRORS', e.response.data.errors);
                    let errors = {
                        email: {
                            fr: i18n.messages['fr']['email_error'],
                            en: i18n.messages['en']['email_error'],
                        },
                    }
                    commit('SET_ERRORS', errors)
                    commit('SET_REGISTERED', false)
                } else if (e.response.status === 500) {
                    ///commit('SET_ERRORS', e.response.data.errors);
                    let errors = {
                        connexion: {
                            fr: i18n.messages['fr']['connexion_error'],
                            en: i18n.messages['en']['connexion_error'],
                        },
                    }
                    commit('SET_ERRORS', errors)
                    commit('SET_REGISTERED', false)
                } else {
                    commit('SET_ERRORS', e.response.data)
                    commit('SET_REGISTERED', false)
                }
            }
        },
        async logout({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('/logout')
                if (response.status >= 200 && response.status <= 299) {
                    commit('SET_USER', {})
                    commit('SET_AUTHENTICATED', false)
                } else {
                    commit('SET_ERRORS', response.data)
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },
        async clear({ commit }) {
            commit('CLEAR_ERRORS')
        },
        async getcountries({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('paysorigine')
                let countries = response.data.data
                commit('SET_COUNTRIES', countries)
            } catch (e) {
                console.log(e)
            }
        },
        async getBirthCountries({ commit }) {
            try {
                let response = await axios.post('pays')
                let birthCountries = response.data
                commit('SET_BIRTHCOUNTRIES', birthCountries)
            } catch (e) {
                console.log(e)
            }
        },
        async getnationalities({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('nationalites')

                console.log(response)
                let nationalities = response.data
                commit('SET_NATIONALITIES', nationalities)
            } catch (e) {
                console.log(e)
            }
        },
        async gettypesvisa({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('typevisas')
                    // let typesvisa = response.data

                let typesvisa = Object.entries(response.data.data).map((arr) => ({
                    id: arr[1].id,
                    visa_designation: arr[1].designation
                }))

                console.log(typesvisa)

                commit('SET_TYPESVISA', typesvisa)
            } catch (e) {
                console.log(e)
            }
        },
        async newdemandSetp1({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/1', payload)
                return response.data
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },
        async newdemandSetp2({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/2', payload)
                return response.data
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },
        async newdemandSetp3({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/3', payload)
                return response.data
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },
        async newdemandSetp4({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/4', payload)
                return response.data
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },

        async newdemandSetpPending({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/pending', payload)
                return response.data
            } catch (error) {
                if (error.response) {
                    if (error.response.status == 401) {
                        let { connected } = { user: null, connected: false }
                        commit('SET_AUTHENTICATED', connected)
                    }
                }
            }
        },

        async payment({ commit }, payload) {
            var stripe = Stripe(
                'pk_test_51J0q6GA8e7XVSZ9orsWz93AzcruGR168dwJUScDHpMFj79wQsAhvQtjSdvtiyCsGTGvyDIjfbXqRhsE3Wswzr9VL00qPZY6Pv2',
            )
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('checkoutpayment', payload)
                return stripe.redirectToCheckout({ sessionId: response.data.id })
            } catch (e) {
                console.log(e)
            }
        },
        async getdemand({ commit }) {
            console.log(this.state.sejourdays)
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('listeDemande')

                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async getidtransaction({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('demandedemandeur', payload)
                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async ticket({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('ticket/store', payload)

                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async cloturer_ticket({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('ticket/update/' + payload.get('id'), payload)

                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async getListesTickets({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('ticket/listeTickets')
                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async contact({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('contactusemail', payload)
                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        async setlanguage({ commit }, payload) {
            commit('SET_LANGLOCAL', payload)
        },
        async setdark({ commit }, payload) {
            commit('SET_ISDARK', payload)
        },
        async getDemandByCode({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post(
                    'showdemande/' + payload.get('code_demande'),
                    payload,
                )
                if (response.status == 200) {
                    return response.data
                }
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async getDemandByCodePending({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post(
                    'showdemande/pending/' + payload.get('code_demande'),
                    payload,
                )
                if (response.status == 200) {
                    return response.data
                }
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async updateDemande({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post(
                    'showdemande/updatedemande/' + payload.get('code_demande'),
                    payload,
                )
                if (response.status == 200) {
                    return response.data
                }
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async saveDemandeUpdate({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post(
                    'updatedemande/' + payload.get('code_demande'),
                    payload,
                )
                if (response.status == 200) {
                    return response.data
                }
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async getVisaInfo({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post(
                    'showdemande/' + payload.get('code_demande'),
                    payload,
                )

                if (response.status == 200) {
                    return response.data
                }
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async resetPassword({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                console.log(payload.get('token'))
                let response = await axios.post('reset-password/' + payload.get('token'), payload)

                return response
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async checkMail({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')

            try {
                let response = await axios.post('checkemail  ', payload)
                return response
            } catch (error) {
                return {
                    error: error,
                }
            }
        },
        async getnationalityonpassport({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('passnationality', payload)
                return response
            } catch (error) {
                console.log(error)
            }
        },
        async checkHavePending({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('step/last', payload)
                return response
            } catch (error) {
                console.log(error)
            }
        },

        async getRdvDemands({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('rdv/listedemande')
                return response
            } catch (error) {
                console.log(error)
            }
        },
        async getRdvHours({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('rdv/meeting/' + payload.get('code'), payload)
                return response
            } catch (error) {
                console.log(error)
            }
        },

        async takRdvDemands({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('rdv/store', payload)
                return response
            } catch (error) {
                console.log(error)
            }
        },
        async getInfoTokenDemande({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('document/demande', payload)
                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        async getInfoTokenApproved({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('document/approved', payload)
                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        async getDemandFormular({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('document/demandformular', payload)
                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        async getEdocument({ commit }) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('edocuments')
                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        async getEdocumentByDate({ commit }, payload) {
            await axios.get('sanctum/csrf-cookie')
            try {
                let response = await axios.post('edocuments  ', payload)
                return response.data
            } catch (error) {
                console.log(error)
            }
        }

    },
    plugins: [createPersistedState()],
})

export default store